import React, { useState, useEffect } from "react";
import "./Contact.css";
import { useNavigate } from "react-router-dom";
import emailjs from "@emailjs/browser";
import logo from "./media/logo.png";
import QRCode from "./media/qr_code.svg";

const NAV_ITEMS = [
  { label: "About Us", path: "/about", type: "page" },
  { label: "Our Team", path: "/team", type: "page" },
  { label: "Services", path: "/#services", type: "scroll" },
  { label: "Contact", path: "/contact", type: "page" }
];

function Contact() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNav = (item) => {
    setMenuOpen(false);
    if (item.type === "scroll") {
        navigate("/");
        setTimeout(() => {
            const el = document.querySelector(item.path.replace("/", ""));
            if (el) el.scrollIntoView({ behavior: "smooth" });
        }, 100);
    } else {
        navigate(item.path);
        window.scrollTo(0, 0);
    }
  };

  const handleInputChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Add your keys here
    emailjs.send(
      "YOUR_SERVICE_ID", "YOUR_TEMPLATE_ID", 
      { from_name: formData.name, from_email: formData.email, message: formData.message },
      { publicKey: "YOUR_PUBLIC_KEY" }
    )
    .then(() => { setIsSubmitted(true); setFormData({ name: "", email: "", message: "" }); })
    .finally(() => setIsSubmitting(false));
  };

  return (
    <div className="App contact-page-wrapper">
      <div className={`dimming-overlay ${menuOpen ? "active" : ""}`} onClick={() => setMenuOpen(false)}></div>

      <header className={`App-header ${scrolled ? "scrolled" : ""}`}>
        <a className="logo" href="/" onClick={(e) => { e.preventDefault(); navigate("/"); }}>
          <img src={logo} alt="Logo" className="header-logo" />
        </a>
        <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
          <div className="bar"></div><div className="bar"></div><div className="bar"></div>
        </div>
      </header>

      <nav className={`dropdown-menu ${menuOpen ? "open" : ""}`}>
        <ul>
          {NAV_ITEMS.map((item, index) => (
            <li className="dropdown-item" key={index}>
              <a onClick={() => handleNav(item)}>{item.label}</a>
            </li>
          ))}
        </ul>
      </nav>

      <section className="contact-hero">
        <div className="container">
          <h1>Contact Us</h1>
          <div className="contact-divider"></div>
        </div>
      </section>

      <section className="section contact-section">
        <div className="container contact-grid">
          <div className="info-box">
            <h2>Get In Touch</h2>
            <div className="info-item">
               <i className="fas fa-map-marker-alt"></i>
               <p>Fortis Tower, 3rd Floor, Westlands</p>
            </div>
            <div className="info-item">
               <i className="fas fa-envelope"></i>
               <p>info@merkel.co.ke</p>
            </div>
            <div className="info-item">
               <i className="fas fa-phone"></i>
               <p>+254 743 933 520</p>
            </div>
            <div className="qr-container"><img src={QRCode} alt="QR Code" /></div>
          </div>

          <div className="form-box">
            {isSubmitted ? <p className="success-msg">Message Sent!</p> : (
              <form onSubmit={handleSubmit}>
                <div className="floating-label">
                  <input type="text" name="name" placeholder=" " value={formData.name} onChange={handleInputChange} required />
                  <label>Name</label>
                </div>
                <div className="floating-label">
                  <input type="email" name="email" placeholder=" " value={formData.email} onChange={handleInputChange} required />
                  <label>Email</label>
                </div>
                <div className="floating-label">
                  <textarea name="message" rows="5" placeholder=" " value={formData.message} onChange={handleInputChange} required></textarea>
                  <label>Message</label>
                </div>
                <button type="submit" className="submit-btn" disabled={isSubmitting}>
                  {isSubmitting ? "Sending..." : "Send"}
                </button>
              </form>
            )}
          </div>
        </div>
      </section>

      {/* Footer Links & Map */}
      <section className="section gray-bg">
         <div className="container footer-links-grid">
            <div className="links-column">
               <h3>Quick Links</h3>
               <ul>
                 <li><a onClick={() => handleNav({path: "/Support"})}>Support Services</a></li>
                 <li><a onClick={() => handleNav({path: "/Focus"})}>Focus Industry</a></li>
                 <li><a onClick={() => handleNav({path: "/Future"})}>Future Outlook</a></li>
                 <li><a onClick={() => handleNav({path: "/Assurance"})}>Quality Assurance</a></li>
                 <li><a onClick={() => handleNav({path: "/Confidentiality"})}>Confidentiality</a></li>
                 <li><a onClick={() => handleNav({path: "/Indemnity"})}>Professional Indemnity</a></li>
               </ul>
            </div>
            <div className="map-column">
               <iframe title="Map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.819165999999!2d36.804285!3d-1.264763!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f10d7b3f5b5b5%3A0x5f0f0f0f0f0f0f0f!2sFortis%20Tower%2C%20Nairobi!5e0!3m2!1sen!2ske!4v1633024000000!5m2!1sen!2ske" width="100%" height="250" style={{border:0}} allowFullScreen></iframe>
            </div>
         </div>
      </section>

      <footer className="App-footer">
        <p>© 2025 MERKEL & ASSOCIATES ADVOCATES.</p>
      </footer>
    </div>
  );
}

export default Contact;